"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOP_SPEAKING_ACTIVITY = void 0;
exports["default"] = stopSpeakingActivity;
var STOP_SPEAKING_ACTIVITY = 'WEB_CHAT/STOP_SPEAKING';
exports.STOP_SPEAKING_ACTIVITY = STOP_SPEAKING_ACTIVITY;

function stopSpeakingActivity() {
  return {
    type: STOP_SPEAKING_ACTIVITY
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTVE9QX1NQRUFLSU5HX0FDVElWSVRZIiwic3RvcFNwZWFraW5nQWN0aXZpdHkiLCJ0eXBlIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc3RvcFNwZWFraW5nQWN0aXZpdHkuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU1RPUF9TUEVBS0lOR19BQ1RJVklUWSA9ICdXRUJfQ0hBVC9TVE9QX1NQRUFLSU5HJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc3RvcFNwZWFraW5nQWN0aXZpdHkoKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU1RPUF9TUEVBS0lOR19BQ1RJVklUWVxuICB9O1xufVxuXG5leHBvcnQgeyBTVE9QX1NQRUFLSU5HX0FDVElWSVRZIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxzQkFBc0IsR0FBRyx3QkFBL0I7OztBQUVlLFNBQVNDLG9CQUFULEdBQWdDO0VBQzdDLE9BQU87SUFDTEMsSUFBSSxFQUFFRjtFQURELENBQVA7QUFHRCJ9